import { render } from "./PostPage.vue?vue&type=template&id=b91c0304&scoped=true"
import script from "./PostPage.vue?vue&type=script&lang=js"
export * from "./PostPage.vue?vue&type=script&lang=js"

import "./PostPage.vue?vue&type=style&index=0&id=b91c0304&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b91c0304"]])

export default __exports__